import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type StoryList = paths['/v4/story/{type}/'];

const getStoryList = createRequest<StoryList>('/pc/v4/story/{type}/');

export default getStoryList;
